module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticeArmsFolded-ae02d69d86e93dfd0afff07429891ee6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticeArmsFolded.png
// module id = 2474
// module chunks = 2